import { Flex } from 'antd';
import styled from 'styled-components';

export default styled(Flex)`
	// Add your styles here
`;
